'use client'

import React from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { SearchFormValues, searchSchema } from '@/utils/schemas'

import { useSearchParams } from 'next/navigation'
import { HeaderProps } from '@/layouts/Header/Header'

interface SearchFormProps extends HeaderProps {
  onSearch: (search_q: string, cate_code: string) => void
}

const SearchForm: React.FC<SearchFormProps> = ({ onSearch, menus = [] }) => {
  const searchParams = useSearchParams()!
  const searchQuery = searchParams.get('search_q') || ''
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SearchFormValues>({
    resolver: zodResolver(searchSchema),
    defaultValues: {
      search_q: searchQuery,
      cate_code: 'all',
    },
  })

  // Xử lý form
  const onSubmit = (data: SearchFormValues) => {
    onSearch(data.search_q, data.cate_code)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 relative pb-5 border-b mb-5">
      <div>
        <label htmlFor="search_q" className="block text-sm font-medium text-gray-700 mb-2">
          Từ khoá
        </label>
        <div className="relative">
          <input
            type="text"
            id="search_q"
            placeholder="Nhập từ khóa"
            {...register('search_q')}
            className={`w-full border ${
              errors.search_q ? 'border-red-500' : 'border-gray-300'
            } rounded-md p-3 pr-12`}
          />
          <button
            type="submit"
            aria-label="fa search button"
            className="absolute inset-y-0 right-0 flex items-center justify-center w-10 h-full text-gray-500 hover:text-gray-700"
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
        {errors.search_q && <p className="text-red-500 text-sm mt-1">{errors.search_q.message}</p>}
      </div>

      <div>
        <label htmlFor="cate_code" className="block text-sm font-medium text-gray-700 mb-2">
          Chuyên mục
        </label>
        <select
          id="cate_code"
          {...register('cate_code')}
          className={`w-full border ${
            errors.cate_code ? 'border-red-500' : 'border-gray-300'
          } rounded-md p-3`}
        >
          <option value="all">Tất cả</option>
          {menus.map((category) => (
            <option key={category.id} value={category.slug}>
              {category.categoryName}
            </option>
          ))}
        </select>
        {errors.cate_code && (
          <p className="text-red-500 text-sm mt-1">{errors.cate_code.message}</p>
        )}
      </div>
    </form>
  )
}

export default SearchForm
